import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-md-12" }
const _hoisted_2 = { class: "section-title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  alt: "section-shape",
  src: "https://cdn.proxyscrape.com/img/section-shape.png"
}, null, -1)



// eslint-disable-next-line vue/no-setup-props-destructure

export default /*#__PURE__*/_defineComponent({
  props: {
  head: Object,
},
  setup(__props) {

const { head } = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(__props.head.title), 1),
      _hoisted_3,
      _createElementVNode("p", null, _toDisplayString(__props.head.subtitle), 1)
    ])
  ]))
}
}

})